export default "__VITE_ASSET__083adc7a__"